import {gql} from '@apollo/client';
import {Button, Form} from '@telia/styleguide';
import React, {FC} from 'react';

import saveChangelogMutation from '../../graphql/mutation/saveChangelog.graphql';

import {Entity, useFormState} from '../../hooks/useFormState';
import {useMutationWrap} from '../../hooks/useMutationWrap';
import {getLog} from '../../log';
import {Changelog, ChangelogInput} from '../../model';
import FormColumn from '../common/FormColumn';
import FormRow from '../common/FormRow';
import {FieldTypes, FieldWithFormState} from '../common/field';

const log = getLog('Changelog Form', 'INFO');

interface ChangelogsProps {
  changelog?: Changelog;
  refetch?: () => void;
}

export const ChangelogForm: FC<ChangelogsProps> = ({changelog, refetch}) => {
  const formState = useFormState({
    isEditing: true,
    fixedFields: {id: changelog?.id},
    initialEntity: changelog as unknown as Entity,
  });

  log.debug('ChangelogForm', changelog);

  const saveChangelog = useMutationWrap<{saveChangelog: Changelog}, {changelog: ChangelogInput}>(
    gql(saveChangelogMutation)
  );

  const onSaveChangelog = async () => {
    const {modifiedDate, createdDate, ...changelog} = {
      ...formState.entityAs<Changelog>(),
    };
    log.debug('onSaveChangelog', {changelog});

    await saveChangelog({
      loadingText: 'Saving Changelog...',
      successText: 'Changelog saved',
      variables: {
        changelog,
      },
    });

    refetch && refetch();
  };

  return (
    <div className="marginBottom2 form--compact">
      <Form>
        <FormRow>
          <FormColumn>
            <FieldWithFormState formState={formState} entityFieldId="name" label="Name" />
            <div />
          </FormColumn>
          <FormColumn>
            <FieldWithFormState
              formState={formState}
              type={FieldTypes.textarea}
              entityFieldId="description"
              label="Description"
            />
          </FormColumn>
        </FormRow>

        <div>
          <Button text="Save" onClick={onSaveChangelog} kind={Button.kinds.primary} />
        </div>
      </Form>
    </div>
  );
};
